import React from "react";
import { StyleSheet } from "react-native";
import { Card, Paragraph } from "react-native-paper";
import { FieldDisplayRendererProps } from "./types";

export const RichTextDisplayRenderer = ({
  value,
}: FieldDisplayRendererProps) => {
  return (
    <Card style={styles.card}>
      <Card.Content>
        <Paragraph>{value}</Paragraph>
      </Card.Content>
    </Card>
  );
};

const styles = StyleSheet.create({
  card: {
    marginVertical: 8,
    padding: 8,
  },
});
